import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  WritableSignal,
  inject,
  signal
} from "@angular/core";
import { LowerCasePipe } from "@angular/common";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { EbuCarModelResponse } from "src/domain/client";
import {
  selectEbuCar,
  selectEbuCars,
  selectSelectedEbuCarId
} from "src/app/state";
import { PricePipe } from "src/app/pipes/sharedpipes/price.pipe";
import { ImageResolverPipe } from "src/app/pipes/sharedpipes/image-resolver.pipe";
import { CarSegmentKeyPipe } from "src/app/pipes/car-segment-key.pipe";
import { ButtonComponent } from "../../inputs/button/button.component";
import { ViewMoreComponent } from "../view-more/view-more.component";

@Component({
  selector: "app-ebu-selection",
  templateUrl: "./ebu-selection.component.html",
  styleUrl: "./ebu-selection.component.scss",
  imports: [
    TranslateModule,
    PricePipe,
    LowerCasePipe,
    CarSegmentKeyPipe,
    ButtonComponent,
    ViewMoreComponent,
    ImageResolverPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EbuSelectionComponent {
  private readonly store = inject(Store);

  // TODO: Find a correct fallback image
  readonly mockEbuCarImageUrl =
    "https://pics.vwgroup.se/prod/TOP/small/Cykelhallare_Volkswagen_9299.jpg";

  readonly ebuCars: Signal<EbuCarModelResponse[] | null> =
    this.store.selectSignal(selectEbuCars);
  readonly selectedEbuCarId: Signal<string | null> = this.store.selectSignal(
    selectSelectedEbuCarId
  );
  readonly ebuCarsLimit: WritableSignal<number> = signal<number>(5);

  onEbuCarSelected(groupID: string | undefined): void {
    this.store.dispatch(
      selectEbuCar({
        groupID: groupID === this.selectedEbuCarId() ? null : (groupID ?? null)
      })
    );
  }

  toggleEbuCarsLimit(total: number): void {
    this.ebuCarsLimit.update((current) => (current < total ? total : 5));
  }
}
